export const CANCEL_PERSON_VEHICLE_EDIT_STATE = "cancelPersonVehicleEditState";
export const DELETE_PERSON_VEHICLE = "deletePersonVehicle";
export const FETCH_PERSON_VEHICLE_LIST = "fetchPersonVehicleList";
export const SAVE_EDITED_PERSON_VEHICLE = "saveEditedPersonVehicle";
export const SAVE_NEW_PERSON_VEHICLE = "saveNewPersonVehicle";
export const UPDATE_PERSON_VEHICLE = "updatePersonVehicle";


